
<div>
  <div v-for="section in handler.dateSections(lowerQ)">
    <field-item
        :disabled="handler.isDisabled(section, parentTreeContext)"
        @click="select(section.select(section))"
    >
      <row>
        <prefix>
          <icon glyph="datepicker" />
        </prefix>
        <column>
          {{section.label}}
        </column>
      </row>
    </field-item>
  </div>
</div>
